import React, { useEffect, useState } from "react";
import { progressService } from "../../../../../../services/progressService.js";
import StakeholderCardPreview from "./StakeholderCardPreview";

export const StakeholderCardWithData = ({ userId, stakeholderIndex = 1 }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (!userId) return;

      try {
        setLoading(true);

        // Fetch the widget data
        const res = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "interpersonal",
          "stakeholder_values_widget"
        );

        const payload = res?.payload;
        if (!payload) {
          setData(null);
          return;
        }

        // selectedStakeholders → name, role, avatar
        const selected = payload.selectedStakeholders?.[stakeholderIndex - 1];

        // stakeholderData → values, kpis, interests
        const key = `stakeholder${stakeholderIndex}`;
        const formData = payload.stakeholderData?.[key];

        if (!selected || !formData) {
          setData(null);
          return;
        }

        // Final combined data
        setData({
          stakeholder: {
            id: selected.id,
            name: selected.name,
            role: selected.role,
            avatar: selected.avatar,
          },
          stakeholderNumber: stakeholderIndex,
          values: formData.values || [],
          kpis: formData.kpis || [],
          interests: formData.interests || [],
        });
      } catch (err) {
        console.error("❌ Error loading card:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [userId, stakeholderIndex]);

  if (loading) return <p>Loading...</p>;
  if (!data) return <p>No stakeholder data found.</p>;

  return (
    <StakeholderCardPreview
      stakeholder={data.stakeholder}
      stakeholderNumber={data.stakeholderNumber}
      values={data.values}
      kpis={data.kpis}
      interests={data.interests}
    />
  );
};

export default StakeholderCardWithData;
